/**
 * @generated SignedSource<<74416e29ea896c1b2f0062f3977c1ead>>
 * @relayHash dc77f6116fa22ba39c879a394729b97f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc77f6116fa22ba39c879a394729b97f

import { ConcreteRequest } from 'relay-runtime';
export type GlobalDataContainerQuery$variables = Record<PropertyKey, never>;
export type GlobalDataContainerQuery$data = {
  readonly breakingNewsBanner: {
    readonly buttonText: string;
    readonly buttonUrl: string;
    readonly content: ReadonlyArray<{
      readonly html: string;
    }>;
    readonly heading: string;
  } | null;
  readonly footerNav: {
    readonly menuItems: {
      readonly nodes: ReadonlyArray<{
        readonly label: string;
        readonly menuItems: ReadonlyArray<{
          readonly label: string;
          readonly url: string | null;
        }>;
        readonly url: string | null;
      }>;
    } | null;
  } | null;
  readonly mainNav: {
    readonly menuItems: {
      readonly nodes: ReadonlyArray<{
        readonly label: string;
        readonly menuItems: ReadonlyArray<{
          readonly label: string;
          readonly url: string | null;
        }>;
        readonly url: string | null;
      }>;
    } | null;
  } | null;
  readonly newsletters: ReadonlyArray<{
    readonly default: boolean;
    readonly frequency: string;
    readonly image: {
      readonly thumbnails: {
        readonly original: {
          readonly url: string;
        };
      };
    } | null;
    readonly listId: string;
    readonly promoText: {
      readonly html: string;
    };
    readonly slug: string;
    readonly title: string;
  }> | null;
  readonly siteSettings: {
    readonly placeholderImage: {
      readonly thumbnails: {
        readonly horizontal: {
          readonly url: string;
        };
        readonly social: {
          readonly url: string;
        };
        readonly square: {
          readonly url: string;
        };
        readonly vertical: {
          readonly url: string;
        };
      };
    } | null;
    readonly seo: {
      readonly defaultSchema: {
        readonly facebookAppId: string | null;
        readonly googleSiteVerification: string | null;
        readonly title: string | null;
      } | null;
      readonly newsMediaOrganizationSchema: {
        readonly description: string | null;
        readonly diversityPolicyUrl: string | null;
        readonly ethicsPolicyUrl: string | null;
        readonly founders: ReadonlyArray<string>;
        readonly foundingDate: string | null;
        readonly knowsAbout: ReadonlyArray<string>;
        readonly linkedInUrl: string | null;
        readonly mastheadUrl: string | null;
        readonly wikipediaUrl: string | null;
      } | null;
    } | null;
    readonly siteDomain: string;
    readonly siteLogo: {
      readonly originalHeight: number;
      readonly originalWidth: number;
      readonly thumbnails: {
        readonly original: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly url: string;
        };
        readonly social: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly url: string;
        };
      };
    } | null;
    readonly siteSlug: string;
    readonly siteTagline: string | null;
    readonly siteTitle: string;
    readonly socialMediaLinks: ReadonlyArray<{
      readonly platformName: string;
      readonly url: string;
    }>;
  };
  readonly wikiBanner: {
    readonly buttonText: string;
    readonly buttonUrl: string;
    readonly content: ReadonlyArray<{
      readonly html: string;
    }>;
    readonly heading: string;
    readonly showOnHomepage: boolean;
  } | null;
};
export type GlobalDataContainerQuery = {
  response: GlobalDataContainerQuery$data;
  variables: GlobalDataContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buttonText",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buttonUrl",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "html",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RichTextType",
  "kind": "LinkedField",
  "name": "content",
  "plural": true,
  "selections": (v2/*:: as any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "heading",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "BannerType",
  "kind": "LinkedField",
  "name": "breakingNewsBanner",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    (v3/*:: as any*/),
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "BannerType",
  "kind": "LinkedField",
  "name": "wikiBanner",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    (v3/*:: as any*/),
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showOnHomepage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "siteDomain",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "siteSlug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "siteTitle",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "siteTagline",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = [
  (v11/*:: as any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ThumbnailMapType",
  "kind": "LinkedField",
  "name": "thumbnails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailType",
      "kind": "LinkedField",
      "name": "horizontal",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailType",
      "kind": "LinkedField",
      "name": "vertical",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailType",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailType",
      "kind": "LinkedField",
      "name": "social",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalWidth",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalHeight",
  "storageKey": null
},
v16 = [
  (v11/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CoordinatesType",
    "kind": "LinkedField",
    "name": "cropCoordinates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ThumbnailMapType",
  "kind": "LinkedField",
  "name": "thumbnails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailType",
      "kind": "LinkedField",
      "name": "original",
      "plural": false,
      "selections": (v16/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailType",
      "kind": "LinkedField",
      "name": "social",
      "plural": false,
      "selections": (v16/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "SocialMediaLink",
  "kind": "LinkedField",
  "name": "socialMediaLinks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platformName",
      "storageKey": null
    },
    (v11/*:: as any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "SEOSettingsType",
  "kind": "LinkedField",
  "name": "seo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultSchemaType",
      "kind": "LinkedField",
      "name": "defaultSchema",
      "plural": false,
      "selections": [
        (v19/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "facebookAppId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "googleSiteVerification",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NewsMediaOrganizationSchemaType",
      "kind": "LinkedField",
      "name": "newsMediaOrganizationSchema",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "foundingDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "founders",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "knowsAbout",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diversityPolicyUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ethicsPolicyUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mastheadUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wikipediaUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkedInUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "default",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "RichTextType",
  "kind": "LinkedField",
  "name": "promoText",
  "plural": false,
  "selections": (v2/*:: as any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequency",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "ThumbnailMapType",
  "kind": "LinkedField",
  "name": "thumbnails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailType",
      "kind": "LinkedField",
      "name": "original",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "location",
    "value": "MAIN"
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NavMenuToNavMenuItemsConnection",
    "kind": "LinkedField",
    "name": "menuItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NavMenuItemType",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v28/*:: as any*/),
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NavMenuItemType",
            "kind": "LinkedField",
            "name": "menuItems",
            "plural": true,
            "selections": [
              (v28/*:: as any*/),
              (v11/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v30 = [
  {
    "kind": "Literal",
    "name": "location",
    "value": "FOOTER"
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v32 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NavMenuToNavMenuItemsConnection",
    "kind": "LinkedField",
    "name": "menuItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NavMenuItemType",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v28/*:: as any*/),
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NavMenuItemType",
            "kind": "LinkedField",
            "name": "menuItems",
            "plural": true,
            "selections": [
              (v28/*:: as any*/),
              (v11/*:: as any*/),
              (v31/*:: as any*/)
            ],
            "storageKey": null
          },
          (v31/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalDataContainerQuery",
    "selections": [
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SiteSettingsType",
        "kind": "LinkedField",
        "name": "siteSettings",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageResourceType",
            "kind": "LinkedField",
            "name": "placeholderImage",
            "plural": false,
            "selections": [
              (v13/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageResourceType",
            "kind": "LinkedField",
            "name": "siteLogo",
            "plural": false,
            "selections": [
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v17/*:: as any*/)
            ],
            "storageKey": null
          },
          (v18/*:: as any*/),
          (v20/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NewsletterType",
        "kind": "LinkedField",
        "name": "newsletters",
        "plural": true,
        "selections": [
          (v19/*:: as any*/),
          (v21/*:: as any*/),
          (v22/*:: as any*/),
          (v23/*:: as any*/),
          (v24/*:: as any*/),
          (v25/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageResourceType",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v26/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "mainNav",
        "args": (v27/*:: as any*/),
        "concreteType": "NavMenuType",
        "kind": "LinkedField",
        "name": "navMenu",
        "plural": false,
        "selections": (v29/*:: as any*/),
        "storageKey": "navMenu(location:\"MAIN\")"
      },
      {
        "alias": "footerNav",
        "args": (v30/*:: as any*/),
        "concreteType": "NavMenuType",
        "kind": "LinkedField",
        "name": "navMenu",
        "plural": false,
        "selections": (v29/*:: as any*/),
        "storageKey": "navMenu(location:\"FOOTER\")"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GlobalDataContainerQuery",
    "selections": [
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SiteSettingsType",
        "kind": "LinkedField",
        "name": "siteSettings",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageResourceType",
            "kind": "LinkedField",
            "name": "placeholderImage",
            "plural": false,
            "selections": [
              (v13/*:: as any*/),
              (v31/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageResourceType",
            "kind": "LinkedField",
            "name": "siteLogo",
            "plural": false,
            "selections": [
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v17/*:: as any*/),
              (v31/*:: as any*/)
            ],
            "storageKey": null
          },
          (v18/*:: as any*/),
          (v20/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NewsletterType",
        "kind": "LinkedField",
        "name": "newsletters",
        "plural": true,
        "selections": [
          (v19/*:: as any*/),
          (v21/*:: as any*/),
          (v22/*:: as any*/),
          (v23/*:: as any*/),
          (v24/*:: as any*/),
          (v25/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageResourceType",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v26/*:: as any*/),
              (v31/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "mainNav",
        "args": (v27/*:: as any*/),
        "concreteType": "NavMenuType",
        "kind": "LinkedField",
        "name": "navMenu",
        "plural": false,
        "selections": (v32/*:: as any*/),
        "storageKey": "navMenu(location:\"MAIN\")"
      },
      {
        "alias": "footerNav",
        "args": (v30/*:: as any*/),
        "concreteType": "NavMenuType",
        "kind": "LinkedField",
        "name": "navMenu",
        "plural": false,
        "selections": (v32/*:: as any*/),
        "storageKey": "navMenu(location:\"FOOTER\")"
      }
    ]
  },
  "params": {
    "id": "dc77f6116fa22ba39c879a394729b97f",
    "metadata": {},
    "name": "GlobalDataContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2fd6dc06ea95c33c58fd2fedf8292ee2";

export default node;
